/**
 * Terms Modal
 * @requires https://getbootstrap.com
 * Creates and injects a Bootstrap modal with id 'termsModal' into the DOM
 */
/* eslint-disable */
export default (() => {
    // Create the modal HTML structure
    const modalHTML = `
    <div class="modal fade" id="termsModal" tabindex="-1" aria-labelledby="termsModalLabel" aria-hidden="true">
      <div class="modal-dialog modal-lg">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title" id="termsModalLabel">Términos y Condiciones</h5>
            <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
          </div>
          <div class="modal-body">
            <div class="terms-content">
              <!-- Términos y Condiciones -->
<div class="container my-5">
  <h1 class="mb-4 text-center">Términos y Condiciones</h1>

  <section class="mb-5">
    <p>
      Estas condiciones regulan el uso del sitio web de Internet
      <a href="https://www.savitat.com" class="text-decoration-none">www.savitat.com</a>
      que SAVITAT, Inc. pone gratuitamente a disposición de los usuarios de Internet.
    </p>
    <p>
      La utilización de la Web de SAVITAT, Inc. atribuye la condición de usuario del
      sitio web (en adelante, el <strong>«Usuario»</strong>) y expresa la aceptación plena
      y sin reservas del Usuario de todas y cada una de las condiciones y restricciones
      que estén publicadas en la Web en el momento en que el Usuario acceda a la misma.
      El Usuario debe leer atentamente y cumplir con los Términos y Condiciones y, según
      sea el caso, con las Condiciones Particulares de los servicios que se ofrecen en
      la misma, así como con las instrucciones y advertencias comunicadas al Usuario
      (todas ellas, <strong>«Términos y Condiciones de Uso»</strong>).
    </p>
    <p>
      El acceso a la Web y/o la utilización de cualquiera de los servicios en ella
      incluidos supondrá la aceptación de todos los Términos y Condiciones.
      SAVITAT, Inc. se reserva el derecho a modificar unilateralmente la Web y los
      servicios en ella ofrecidos, incluyendo la modificación de los Términos y
      Condiciones.
    </p>
    <p>
      Se recomienda al Usuario que lea estos Términos y Condiciones tantas veces como
      acceda a la Web.
    </p>
  </section>

  <hr class="my-4">

  <section class="mb-5">
    <h2 class="h4 mb-3">Condiciones de utilización de la Web</h2>
    <p>
      El Usuario se obliga a utilizar la Web de conformidad con los usos autorizados.
      Queda expresamente prohibida la utilización de la Web o de cualquiera de sus
      servicios con fines o efectos ilícitos, contrarios a la buena fe, al orden
      público o a lo establecido en los Términos y Condiciones. Queda igualmente
      prohibido cualquier uso lesivo de derechos o intereses de terceros o que, de
      cualquier forma, dificulten la utilización por parte de otros usuarios la normal
      utilización de la Web y/o sus servicios.
    </p>
    <p>
      SAVITAT, Inc. se reserva el derecho a denegar o retirar el acceso a la Web o
      alguno de sus servicios a cualquier Usuario que incumpla estos Términos y
      Condiciones, las Condiciones Particulares y/o cualquiera de las instrucciones y
      advertencias comunicadas al Usuario.
    </p>
    <p>
      El uso de la Web se realizará bajo la única y exclusiva responsabilidad y riesgo
      del Usuario. SAVITAT, Inc. no se responsabiliza del material que se encuentra
      disponible en la Web. En caso de que el Usuario no esté de acuerdo total o
      parcialmente con los Términos y Condiciones, deberá abstenerse de usar esta
      página web.
    </p>
  </section>

  <hr class="my-4">

  <section class="mb-5">
    <h2 class="h4 mb-3">Cookies</h2>
    <p>
      SAVITAT, Inc. utiliza cookies para registrar las preferencias de los usuarios,
      analizar el tráfico de la Web, evaluar y mejorar el contenido y funciones de la
      Web y optimizar el diseño y los contenidos del mismo. Las cookies son pequeños
      archivos de texto enviados por un sitio web y que se guardan en el disco duro
      del computador. La mayoría de los navegadores aceptan cookies automáticamente.
      El Usuario siempre puede configurar su navegador para rechazar todas las cookies
      de este u otros sitios web que visite. Si el Usuario opta por no aceptar cookies,
      igualmente podrá usar la Web; sin embargo, es posible que algunas partes de la
      Web no funcionen correctamente o se ejecuten lentamente si elige rechazarlas.
      Al usar la Web y no deshabilitar las cookies, el Usuario acepta su uso para los
      propósitos descritos.
    </p>
  </section>

  <hr class="my-4">

  <section class="mb-5">
    <h2 class="h4 mb-3">Política de Privacidad</h2>
    <p>
      Esta Web y sus contenidos están protegidos por las leyes de protección de la
      Propiedad Industrial e Intelectual internacionales y de Panamá, ya sea como
      obras individuales y/o como compilaciones. El Usuario no puede borrar ni
      modificar de ninguna forma la información relativa a esos derechos incluidos en
      la Web. Quedan reservados todos los derechos a favor de SAVITAT, Inc. o del
      titular de los mismos.
    </p>
  </section>

  <section class="mb-5">
    <h2 class="h4 mb-3">Política de Confidencialidad</h2>
    <p>
      Para la utilización de determinados servicios, SAVITAT, Inc. podrá solicitar
      determinados datos del Usuario. SAVITAT, Inc. tratará esos datos de conformidad
      con lo dispuesto en la siguiente política.
    </p>
  </section>

  <section class="mb-5">
    <h2 class="h4 mb-3">Política de Privacidad de Datos</h2>
    <p>
      SAVITAT, Inc. se compromete a respetar y a proteger la privacidad de las personas
      y a mantener la Información Personal segura mediante el cumplimiento de la
      protección de datos aplicable, la privacidad, las leyes y regulaciones sobre
      seguridad de la información. Esta política describe los métodos de SAVITAT, Inc.
      respecto de la recolección necesaria, uso, divulgación y protección de datos
      personales con fines relacionados con los negocios derivados del objeto social y
      actividades económicas de la compañía. SAVITAT, Inc. protegerá la información
      personal y garantizará que dicha información permanezca segura y disponible para
      sus titulares.
    </p>
  </section>

  <hr class="my-4">

  <section class="mb-5">
    <h2 class="h4 mb-3">Derechos de Propiedad Intelectual e Industrial</h2>
    <p>
      Todos los contenidos de la Web (las marcas, nombres comerciales, imágenes,
      iconos y la presentación general de la Web y de sus contenidos) están sujetos a
      derechos de propiedad intelectual o industrial de SAVITAT, Inc. En ningún caso
      el acceso a la Web implica que, por parte de SAVITAT, Inc. o del titular de esos
      derechos: (i) se otorgue autorización o licencia alguna sobre esos contenidos,
      (ii) se renuncie, transmita o ceda total o parcialmente ninguno de sus derechos
      sobre esos contenidos (entre otros, sus derechos de reproducción, distribución y
      comunicación pública).
    </p>
    <p>
      No podrá realizarse cualquier utilización de la Web y/o de los contenidos
      incluidos dentro de ella, diferente de la expresamente autorizada por
      SAVITAT, Inc. Ningún usuario de esta Web puede revender, volver a publicar,
      imprimir, bajar, copiar, retransmitir o presentar (valiéndose de un «frame»
      HTML u otro medio) ningún elemento de esta Web ni de los contenidos de la misma
      sin el consentimiento previo por escrito de SAVITAT, Inc., a menos que la ley
      permita, en medida razonable, copiar o imprimir los contenidos para uso personal
      y no comercial, manteniéndose inalterados, en todo caso, el copyright y demás
      datos identificativos de los derechos de SAVITAT, Inc. y/o del titular de los
      derechos de esos contenidos. Quedan reservados todos los derechos a favor de
      SAVITAT, Inc.
    </p>
  </section>
</div>

            </div>
          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">Cerrar</button>
            <button type="button" class="btn btn-info" id="acceptTerms">Aceptar</button>
          </div>
        </div>
      </div>
    </div>
  `;

    // Function to inject the modal into the DOM
    const injectModal = () => {
        // Check if modal already exists to avoid duplicates
        if (document.getElementById('termsModal')) {
            return;
        }

        // Create a temporary div to hold the modal HTML
        const tempDiv = document.createElement('div');
        tempDiv.innerHTML = modalHTML;

        // Append the modal to the body
        document.body.appendChild(tempDiv.firstElementChild);

        // Add event listener for the accept button
        const acceptButton = document.getElementById('acceptTerms');
        if (acceptButton) {
            acceptButton.addEventListener('click', () => {
                // Hide the modal
                const modal = bootstrap.Modal.getInstance(document.getElementById('termsModal'));
                if (modal) {
                    modal.hide();
                }

                // Dispatch custom event for when terms are accepted
                document.dispatchEvent(new CustomEvent('termsAccepted', {
                    detail: { timestamp: new Date().toISOString() }
                }));
            });
        }
    };

    // Wait for DOM to be ready before injecting
    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', injectModal);
    } else {
        injectModal();
    }

    // Return an object with utility methods for external use
    return {
        show: () => {
            const modalElement = document.getElementById('termsModal');
            if (modalElement) {
                const modal = new bootstrap.Modal(modalElement);
                modal.show();
            }
        },
        hide: () => {
            const modalElement = document.getElementById('termsModal');
            if (modalElement) {
                const modal = bootstrap.Modal.getInstance(modalElement);
                if (modal) {
                    modal.hide();
                }
            }
        }
    };
})();
